
import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();
export default {
  name: "RecapScanOk",
   data () {
    return {
      documents:null,
      showPageRecapScan: 0
    }
  },
  mounted: function () {
  
    this.loadDossier();
    //this.showDossier();
  },

  methods: {
    gotoContactInfo(){
      if(this.$globalService.getSessionSouscription().offreChoisie.type == 'MOB')
        this.$router.push({name: 'ContactMobile'});
      else
        this.$router.push({name: 'Contact'});
    },
    showDossier: function(){
             //récuperation dans la session
             this.$root.progress = true;
             var sessionSouscription = this.$globalService.getSessionSouscription();
             if(sessionSouscription != null && sessionSouscription.resultCheckScan){
               this.documents = sessionSouscription.resultDossierScan.fullDocuments
               this.$root.progress = false;
             }else{
              this.$root.progress = false;
              this.$dialog.error({
                text: this.$root.errorMessage,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
             }
            
          },
    loadDossier: function(){
      this.$root.progress = true;
        //récuperation dans la session
        var sessionSouscription = this.$globalService.getSessionSouscription();
        doccliService.readDossier(sessionSouscription.doccli_id).then(res => {   
          this.$root.progress = false;
          if(res){
            if (res.err !='error') {
              const data = res.params.data;
              this.$globalService.setSessionSouscription('resultDossierScan',data.dossier);
              this.documents = data.dossier.fullDocuments;
             
              this.gotoContactInfo();
                        
            }else{
              this.$dialog.error({
                text: "Récuperation du resultat du traitement impossible suite à une erreur technique",
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
            this.$root.progress = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
        
        
      }
  }
}